import Mailcheck from "mailcheck"
import { removeAccents } from "../helpers/removeAccents"

const topLevelDomains = [
  "com",
  "net",
  "org",
  "ca",
  "fr",
  "ru",
  "info",
  "io",
  "uk"
]

const getEmailSuggestions = email => {
  const normalizedEmail = removeAccents(email.toLowerCase())
  return new Promise(resolve => {
    Mailcheck.run({
      email: normalizedEmail,
      topLevelDomains: topLevelDomains, // optional
      suggested: function(suggestion) {
        resolve(suggestion)
      },
      empty: function() {
        resolve(null)
      }
    })
  })
}

export { getEmailSuggestions }
